import { ITravelHealthInsuranceInitialValues } from '../../../types';

export const INITIAL_VALUES: ITravelHealthInsuranceInitialValues = {
  id: undefined,
  policy_number: '',
  first_name: '',
  last_name: '',
  turkish_id: '',
  birthday: '',
  upload_files: [],
  travel_start_date: '',
  travel_end_date: '',
  countries: [],
  organization: 0,
  email_users: [],
  type: '',
  recent_status: '',
};
